export const KG_BLUE_COLOR = 'interactive-kg-blue';
export const MAJOR = 'major';
export const WINNER_TITLE = 'Winner';
export const TOP_BID_TITLE = 'Top bid';
